"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerService = void 0;
const typescript_logging_1 = require("typescript-logging");
const typescript_logging_category_style_1 = require("typescript-logging-category-style");
// -----------------------------------------------------------------------------
// We use 'typescript-logging' so that in production, where there is a single
// file per-window, we can still understand which class printed a log.
class LoggerService {
    // ---------------------------------------------------------------------------
    static getLogger() {
        if (!this.initialized) {
            this.setup();
        }
        return LoggerService.provider.getCategory('LoggerService');
    }
    // ---------------------------------------------------------------------------
    static setup() {
        const config = this.createLoggerCategoryConfiguration();
        LoggerService.provider =
            typescript_logging_category_style_1.CategoryProvider.createProvider('LoggerService', config);
        this.initialized = true;
    }
    // ---------------------------------------------------------------------------
    static createLoggerCategoryConfiguration() {
        const rawLogMessage = (msg, formatArg) => {
            // We customize the log message to remove the timestamp, as Overwolf
            // already prints the timestamp to the log files.
            const idx = msg.logNames.indexOf('#') + 1;
            const clazz = msg.logNames.slice(idx).toString();
            console.info(`[${clazz}] [${msg.level}] ${msg.message}`);
        };
        const categoryConfig = {
            level: typescript_logging_1.LogLevel.Debug,
            channel: {
                type: 'RawLogChannel',
                write: rawLogMessage
            }
        };
        return categoryConfig;
    }
}
exports.LoggerService = LoggerService;
LoggerService.initialized = false;
//# sourceMappingURL=logger_service.js.map